const en = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    confirm: 'Are you sure?',
    noResults: 'No results found',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    retry: 'Try again',
    yes: 'Yes',
    no: 'No',
  },
  nav: {
    dashboard: 'Dashboard',
    notifications: 'Notifications',
    governance: 'Governance',
    training: 'Training',
    toolMatrix: 'Tool matrix',
    inventory: 'Tool Database',
    employees: 'Team Directory',
    settings: 'Settings',
    billing: 'Billing',
    advisor: 'Advisor',
    portal: 'Portal',
    admin: 'Admin',
  },
  dashboard: {
    title: 'Executive Dashboard',
    subtitle: 'Stop wandering the SaaS desert. Welcome to Oasix, where your tech stack finally makes sense.',
    actions: 'Actions',
    financials: 'Financials',
    knowledge: 'Knowledge',
    governanceTasks: 'Governance tasks',
    pendingRequests: 'Pending Requests',
    pendingTraining: 'Pending Training',
    pendingAccesses: 'Pending accesses',
    totalMonthlySpend: 'Total Monthly Spend',
    criticalityBreakdown: 'Tools by Criticality',
    toolsTotal: 'tools total',
    overdue: 'overdue',
  },
  inventory: {
    title: 'Technology Stack Inventory',
    subtitle: 'Manage your complete list of software tools, pricing models, and ownership.',
    addTool: 'Add Tool',
    searchPlaceholder: 'Search tools or tags...',
    noTools: 'No tools yet. Click "Add Tool" to get started.',
    toolLimitReached: 'Tool limit reached. Upgrade your plan to add more.',
  },
  employees: {
    title: 'Team Directory',
    subtitle: 'Your team members and their tool assignments, training status, and roles.',
    addEmployee: 'Add Employee',
    searchPlaceholder: 'Search employees...',
  },
  governance: {
    title: 'Governance & Renewals',
    subtitle: 'Monitor upcoming contract renewals and notice deadlines.',
    addTask: 'Add Task',
    complianceTasks: 'Compliance & Tasks',
    calendar: 'Calendar',
    showMore: 'Show more',
  },
  training: {
    title: 'Training',
    subtitle: 'Track training completion rates and competency scores.',
    addTraining: 'Add training',
    curriculum: 'Curriculum',
    assignedFormations: 'Assigned formations',
  },
  notifications: {
    title: 'Notification Center',
    subtitle: 'Review incoming requests for access and new tools.',
    pending: 'Pending',
    all: 'All',
  },
  billing: {
    title: 'Billing',
    currentPlan: 'Current Plan',
    trialDaysLeft: '{days} day(s) left in your trial',
    trialExpired: 'Your trial has expired',
    cancelled: 'Your subscription was cancelled',
    subscribe: 'Subscribe',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    monthly: 'Monthly',
    annual: 'Annual',
  },
  settings: {
    title: 'Settings',
    currency: 'Currency',
    categories: 'Categories',
    tags: 'Tags',
    teams: 'Teams',
    criticalityLevels: 'Criticality Levels',
    saveChanges: 'Save Changes',
  },
  advisor: {
    title: 'Oasix Advisor',
    whatCanIHelp: 'What can I help you with?',
    analyzeStack: 'Analyze my stack',
    findReplacement: 'Find replacement',
    consolidateTools: 'Consolidate tools',
    findNewTool: 'Find new tool',
    negotiateRenewal: 'Negotiate renewal',
    askAnything: 'Ask anything',
    askAdvisor: 'Ask Advisor',
    analyzing: 'Analyzing your stack...',
    queriesUsed: '{used}/{included} queries used',
    newQuery: 'New query',
  },
  portal: {
    title: 'My Portal',
    myTools: 'My Tools',
    myTraining: 'My Training',
    requests: 'Requests',
    ideas: 'Ideas',
  },
  features: {
    title: 'Ideas & Feature Requests',
    suggestIdea: 'Suggest an idea',
    mostVoted: 'Most voted',
    newest: 'Newest',
    votes: 'votes',
  },
  readOnly: {
    expiredMessage: 'Your trial has expired. Your data is preserved — subscribe to regain full access.',
    cancelledMessage: 'Your subscription was cancelled. Data is preserved for 90 days.',
    subscribeNow: 'Subscribe Now',
  },
} as const;

export default en;
export type TranslationKeys = typeof en;
